import api from '@/api/fetchClient'

export default {
   AddAccountingYear(payload) {
    return api.post('accounting/year/add', payload, { authorized: true })
    },
   GetAccountingYears() {
    return api.get('accounting/years/get', { authorized: true })
  },
   UpdateAccountingYear(id, payload) {
    return api.put(`accounting/year/${id}`, payload, { authorized: true })
  },
   fetchChartOfAccounts() {
    return api.get('chart-of-accounts/get', { authorized: true })
  },
  AddJournalVoucher(payload) {
    return api.post('journal-voucher/add', payload, { authorized: true })
  },
  fetchJournalVouchers() {
    return api.get('journal-vouchers/get', { authorized: true })
  },
  AddChartOfAccount(payload) {
    return api.post('chart-of-accounts/add', payload, { authorized: true })
  },
  UpdateChartOfAccount(id, payload) {
    return api.put(`chart-of-accounts/${id}`, payload, { authorized: true })
  },
  DeleteChartOfAccount(id) {
    return api.delete(`chart-of-accounts/${id}`, { authorized: true })
  }
}
